// Doctor service for API calls
import apiClient from '../../../services/apiClient';

const doctorService = {
  // Get all doctors for admin interface
  getAllDoctors: async () => {
    try {
      console.log('🔑 Fetching all doctors via apiClient');
      const response = await apiClient.get('/doctors/');
      console.log('✅ Doctors data received:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching doctors:', error);
      throw error;
    }
  },

  // Get doctor by ID
  getDoctorById: async (doctorId) => {
    try {
      const response = await apiClient.get(`/doctors/${doctorId}`);
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching doctor by ID:', error);
      throw error;
    }
  },

  // Create new doctor
  createDoctor: async (doctorData) => {
    try {
      const response = await apiClient.post('/doctors/', doctorData);
      return response.data;
    } catch (error) {
      console.error('❌ Error creating doctor:', error);
      throw error;
    }
  },

  // Create new doctor with user account (for admin use)
  createDoctorWithUser: async (doctorData) => {
    try {
      const response = await apiClient.post('/doctors/create-with-user', doctorData);
      return response.data;
    } catch (error) {
      console.error('❌ Error creating doctor with user:', error);
      if (error.response?.data) {
        throw new Error(typeof error.response.data === 'string' ? error.response.data : JSON.stringify(error.response.data));
      }
      throw error;
    }
  },

  // Update doctor
  updateDoctor: async (doctorId, doctorData) => {
    try {
      const response = await apiClient.put(`/doctors/${doctorId}`, doctorData);
      return response.data;
    } catch (error) {
      console.error('❌ Error updating doctor:', error);
      throw error;
    }
  },

  // Update AC vitals access for doctor
  updateAcVitalsAccess: async (doctorId, acVitalsAccess, accessDays) => {
    try {
      const params = {
        ac_vitals_access: acVitalsAccess
      };
      if (accessDays !== null && accessDays !== undefined) {
        params.access_days = accessDays;
      }
      
      const response = await apiClient.put(`/doctors/${doctorId}/ac-vitals-access`, null, { params });
      return response.data;
    } catch (error) {
      console.error('❌ Error updating AC vitals access:', error);
      throw error;
    }
  },

  // Check AC vitals access for doctor
  checkAcVitalsAccess: async (doctorId) => {
    try {
      const response = await apiClient.get(`/doctors/${doctorId}/ac-vitals-access`);
      return response.data;
    } catch (error) {
      console.error('❌ Error checking AC vitals access:', error);
      throw error;
    }
  },

  // Delete doctor
  deleteDoctor: async (doctorId) => {
    try {
      const response = await apiClient.delete(`/doctors/${doctorId}`);
      return response.data;
    } catch (error) {
      console.error('❌ Error deleting doctor:', error);
      throw error;
    }
  },

  // Get specialties
  getSpecialties: async () => {
    try {
      const response = await apiClient.get('/doctors/specialties');
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching doctor specialties:', error);
      throw error;
    }
  },

  // Search doctors
  searchDoctors: async (searchTerm) => {
    try {
      const response = await apiClient.get(`/doctors/search/${encodeURIComponent(searchTerm)}`);
      return response.data;
    } catch (error) {
      console.error('❌ Error searching doctors:', error);
      throw error;
    }
  },
};

export { doctorService };
export default doctorService;
